export default "__VITE_PUBLIC_ASSET__3ceba569__"